export enum PersonalInfoErrorCode {
  DIRECTOR_MISSING_GENDER = 'DIRECTOR_MISSING_GENDER',
}
